import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_DELETE_FAVORITES, SET_DELETE_FAVORITES, DELETE_FAVORITES_REQUEST_FAILED, SENDING_DELETE_FAVORITES_REQUEST, GET_USER_FAVORITES,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* deleteFavorite(action) {
  const { data } = action;

  try {
    yield put({
      type: SENDING_DELETE_FAVORITES_REQUEST,
      dFData: '',
      isDFSending: true,
      isDFSuccess: false,
      dfError: false,
    });
    const response = yield call(api.favorites.deleteFavorite, data);
    if (response) {
      yield put({ type: GET_USER_FAVORITES, data });
      yield put({
        type: SET_DELETE_FAVORITES,
        dFData: JSON.parse(response.data.Body.toString()),
        isDFSending: false,
        dfError: false,
        isDFSuccess: true,
      });
    } else {
      yield put({
        type: DELETE_FAVORITES_REQUEST_FAILED,
        dFData: null,
        isDFSending: false,
        dfError: true,
        isDFSuccess: false,
        fMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: DELETE_FAVORITES_REQUEST_FAILED,
      fMsg: e.message,
      isDFSending: false,
      dfError: true,
      isDFSuccess: false,
      dFData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchDeleteFavorite() {
  yield takeLatest(GET_DELETE_FAVORITES, deleteFavorite);
}
